import Component from "../../component";

const BodyComponentConfig = {
    baseHtmlClass: 'nav_menu_body',
    selector: '.nav_menu_body'
};

export default class BodyComponent extends Component {

    static new(navMenu) {
        if (!navMenu.element) return null;
        let element = document.body;
        if (!element) return null;
        return new BodyComponent(element, navMenu);
    }

    constructor(id_or_element, navMenu) {
        super({
            element: id_or_element,
            config: BodyComponentConfig
        });

        this.navMenu = navMenu;
    }

    state() {
        return this.navMenu.state();
    }

    // Don't forget that ALL NavMenu instances render to the same body element!
    render() {

        // When closing we restore the scroll position
        if (this.state().closing) {
            window.scrollTo(this.scrollX, this.scrollY);
        }

        this.conditionallySetHtmlClassState(this.state().open, `open_${ this.state().position }`);
        this.conditionallySetHtmlClassState(this.state().modal, 'modal');
    }

}